import * as R from 'ramda';
import React from 'react';
import { withProps, compose } from 'recompose';
import { connect } from 'react-redux';
import PageHeader from 'components/general/PageHeader/PageHeader';
import SubHeader from 'components/general/SubHeader/SubHeader';
import AlertCSVExportForm from './AlertCSVExportForm';
import { createSelector } from 'reselect';
import getSiteQuery from 'selectors/getSiteQuery';
import getUserAbility from 'state/selectors/getUserAbility';
import withQuoteCTA from 'components/hoc/withQuoteCTA';

const getActions = createSelector(
  getSiteQuery,
  getUserAbility,
  (query, ability) => (
    R.pipe(
      R.when(
        () => ability.can('read', 'all'),
        R.append(
          {
            title: 'Export',
            icon: 'download-cloud',
            renderPrompt: () => (
              <div>
                <SubHeader
                  title="Alerts CSV Export"
                  summary="Downloads a full, unfiltered export of all alerts."
                />
                <AlertCSVExportForm />
              </div>
            ),
          },
        ),
      ),
      R.append(R.pipe(
        R.append(
          {
            title: 'List',
            icon: 'list',
            types: ['accent'],
            to: {
              type: 'ALERTS_INDEX',
            },
          },
        ),
        R.append(
          {
            title: 'Map',
            icon: 'map',
            to: {
              query,
              type: 'MAP',
            },
          },
        ),
      )([])),
    )([])
  ),
);

const AlertsPageHeader = compose(
  withProps({
    title: 'Latest alerts',
    section: {
      title: 'Alerts',
    },
  }),
  connect(R.applySpec({
    actions: getActions,
  })),
  withQuoteCTA(),
)(PageHeader);

export default AlertsPageHeader;
